<template>
  <div class="share_manage_background">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item
          class="left_item"
          @click.native="shareManageReturnBtnHandle"
        >
          <img
            class="main_top_img"
            slot="topnavimg"
            src="~assets/img/topnav/zuofanhui.png"
            alt
          />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div slot="topimgtext">分享管理</div>
        </top-nav-item>
        <top-nav-item> </top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="share_manage_page_wraper">
      <div class="share_manage_page_content">
        <config-title-hang>
          <span slot="config_title_hang_ele2">所有的分享链接</span>
        </config-title-hang>

        <div
          v-for="(value, index) in shareListData"
          :key="index"
          class="share_data_wraper"
        >
          <div class="share_left_data">
            <div class="share_left_data_top z_ellipsis1">
              {{ value.businessName }}({{ value.regionName }})
            </div>
            <div class="share_left_data_bottom_start_time">
              <span>创建时间</span>
              <span>{{ value.createTime }}</span>
            </div>

            <div class="share_left_data_bottom_start_time">
              <span>失效时间</span>
              <span>{{ value.invalidTime }}</span>
            </div>
          </div>

          <div class="share_right_data">
            <img
              v-if="value.passwordState === 1"
              class="share_right_data_img_mima"
              src="~/assets/img/config/mimatishi.png"
              alt=""
            />
            <div v-if="value.state === 1" class="share_right_data_text_dis">
              已失效
            </div>
            <!-- 禁用按钮 -->
            <div
              @click="jinYongBtnHandle(value)"
              v-else
              class="share_right_data_text"
            >
              立即禁用
            </div>
            <!-- 拷贝按钮 -->
            <img
              @click="doCopy(value.webpageUrl)"
              v-if="value.state === 0"
              class="share_right_data_img"
              src="~/assets/img/config/copy_lan.png"
              alt=""
            />
            <!-- 删除按钮 -->
            <img
              @click="deleteBtnHandle(shareListData, index)"
              v-if="value.state === 1"
              class="share_right_data_img"
              src="~/assets/img/config/delete_lan.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configTitleHang from 'components/common/config/config-title-hang'

export default {
  data() {
    return {
      shareListData: []
    }
  },
  components: {
    topNav,
    topNavItem,
    configTitleHang
  },
  methods: {
    shareManageReturnBtnHandle() {
      this.$router.go(-1)
    },
    deleteBtnHandle(shareListData, index) {
      console.log('删除按钮被点击了')

      let tempshareIds = []
      tempshareIds.push(shareListData[index].shareId)
      /// 删除分享记录(多条) 接口，获取数据
      this.$request({
        method: 'post',
        url: '/share/deleteShareByIds',
        data: {
          token: this.$store.state.token,
          shareIds: tempshareIds
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            console.log(res.data.data)

            shareListData.splice(index, 1) ////删除数组元素
            console.log(shareListData)

            this.$showTipsToast(1, '删除成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    doCopy(data) {
      // this.dataProcessing(val)
      console.log('复制到粘贴板')

      this.$copyText(data)
        .then(res => {
          console.log(res)
          this.$toast('已复制到粘贴板~', 3000)
          // alert('Copied')
        })
        .catch(err => {
          console.log(err)
          console.log('浏览器限制未能自动复制')
          // this.$toast('未能复制到粘贴板~', 4000)
          // alert('Can not copy')
        })
    },
    jinYongBtnHandle(value) {
      console.log('禁用分享按钮被点击了')

      /// 禁用分享 接口，获取数据
      this.$request({
        method: 'post',
        url: '/share/updateShareById',
        data: {
          token: this.$store.state.token,
          shareId: value.shareId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            console.log(res.data.data)
            value.state = 1 //同步禁用状态
            this.$showTipsToast(1, '禁用成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    /// 分享列表 接口，获取数据
    this.$request({
      method: 'post',
      url: '/share/findShareList',
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.shareListData = res.data.data ////拿到服务器返回的数据结果
          // 按照失效和没失效排序 没失效在前 正序
          this.shareListData.sort(function(a, b) {
            return a.state - b.state
          })
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style>
/* 外包装部分 */
.share_manage_page_wraper {
  max-width: 1200px;
  height: 100%;
  margin: 0 auto; /* 屏幕居中，上下0px  左右自动居中 */
  border-radius: 5px;
  /* box-shadow: 0 0 1px var(--primary-color); */
  box-sizing: border-box;
  padding-top: 0px;
  padding-left: 20px;
  padding-right: 20px;

  /* background: url('../../../assets/img/background/background1.png');
    background-size: 100% auto;  */
  /* 火狐浏览器滚动条隐藏 */
  overflow: auto;
  overflow-y: scroll;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
}

/* Chrome 和 Safari滚动条隐藏 */
.share_manage_page_wraper::-webkit-scrollbar {
  display: none;
}
/* 背景颜色 */
.share_manage_background {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: linear-gradient(rgb(161, 145, 231), blue);
    background: -webkit-linear-gradient(rgb(161, 145, 231), blue);
    background: -o-linear-gradient(rgb(161, 145, 231), blue); 
    background: -moz-linear-gradient(rgb(161, 145, 231), blue); */
}

.share_manage_page_content {
  /* ////  使内容区高一点以便滚动条的滑动 */
  margin-bottom: 500px;
}

/* 分享数据列表样式 */
.share_data_wraper {
  display: flex;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: center;

  position: relative;

  width: 100%;
  height: 80px;
  padding: 0px 10px;

  box-sizing: border-box;
}

.share_left_data {
  display: flex;

  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
}
/* .share_left_data_bottom {
  display: flex;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: center;
} */
.share_right_data {
  display: flex;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
}
.share_data_wraper::after {
  content: '';
  display: inline-block;

  width: 100%;
  height: 1px;

  background-color: #dddddd;

  position: absolute;
  bottom: 0px;
}
.share_data_wraper:hover {
  /* box-shadow: 1px -1px 4px var(--primary-color) inset; */
  background-color: rgba(68, 180, 253, 0.05);
}
.share_left_data_top {
  width: 250px;

  color: #282828;
  font-size: 18px;
}
.share_left_data_bottom_start_time {
  color: #999999;
  font-size: 12px;
}
.share_right_data_text {
  color: var(--primary-color);
  font-size: 18px;
  cursor: pointer; /*移入时光标样式*/

  margin-left: 5px;
}
.share_right_data_text_dis {
  color: #999999;
  font-size: 18px;
  margin-left: 5px;
}
.share_right_data_img {
  width: 24px;
  height: 24px;
  margin-left: 20px;
  cursor: pointer; /*移入时光标样式*/
}
.share_right_data_img_mima {
  height: 14px;
  width: 14px;
}
</style>
